<template>
<div>
    <v-layout row justify-center>
        <v-dialog v-model="selectMatch" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card v-if="selectMatch">
                <v-toolbar color="cyan">

                    <!-- {{selectMatch | halfScore}} -->

                    <span class="mr-1 body-2 white--text" v-show="selectMatch.homeTeam" >{{ selectMatch.homeTeam.teamNameCH }}</span>
                    <span class="ml-1 mr-1 body-1 white--text" v-show="selectMatch.livescore" >{{ selectMatch.livescore.home}}</span> :
                    <span class="ml-1 mr-1 body-1 white--text" v-show="selectMatch.livescore" >{{ selectMatch.livescore.away }}</span>
                    <span class="ml-1 mr-1 body-1 white--text" v-show="selectMatch.livescore" >{{ selectMatch.accumulatedscore | halfScore }}</span>
                    <span class="ml-1 body-2 white--text" v-show="selectMatch.awayTeam" >{{ selectMatch.awayTeam.teamNameCH }}</span>

                    <v-spacer />
                    <v-btn icon dark @click="onClose">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                </v-toolbar>

                <v-layout wrap v-if="hadodds = selectMatch.hadodds">
                    <v-flex xs3>{{ `主客和` }}</v-flex>
                    <v-flex xs9>{{ hadodds.H | parseOdd }}-{{ hadodds.D | parseOdd }}-{{ hadodds.A | parseOdd }}</v-flex>
                </v-layout>

            </v-card>
        </v-dialog>
    </v-layout>
</div>
</template>

<script>
export default {
    props: {
        matchid: String
    },
    watch: {
        matchid(val) {
            if (!val) return;
            this.loadData(val);
        }
    },
    data() {
        return {
            selectMatch: false
        }
    },
    async mounted() {

    },
    filters: {
        halfScore(accumulatedscore) {
            // debugger;
            let output = ' X : X ';
            for (const key in accumulatedscore) {
                if (accumulatedscore.hasOwnProperty(key)) {
                    const element = accumulatedscore[key];
                    if (element.periodvalue == 'FirstHalf') {
                        output = ` ( ${element.home} : ${element.away} ) `;
                        break;
                    }
                }
            }
            return output;
        },
        parseOdd(str) {
            return str.split('@')[1];
        },
        fHadodds(had) {
            if (!had) return '';
            const parseOdd = (str) => {
                return str.split('@')[1];
            }
            return `${parseOdd(had.H)}-${parseOdd(had.D)}-${parseOdd(had.A)}`
        },
    },
    methods: {
        async loadData(id) {
            const response = await this.$http.get(
                `football/hkjc/past/odd/${id}`
            );
            this.selectMatch = response.data;
        },
        parseOdd(str) {
            return str.split('@')[1];
        },
        onClose() {
            this.selectMatch = false;
            // this.$emit('to-close');
        }
    }
}
</script>

<style scoped>

</style>
